import { render, staticRenderFns } from "./ScheduleLayout.vue?vue&type=template&id=388ab734"
import script from "./ScheduleLayout.vue?vue&type=script&lang=ts"
export * from "./ScheduleLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports